import React from "react"
import { Col, Row } from "reactstrap"

import TabRoute from "components/TabRoutes/TabRoute"
import { APP_ROUTES } from "helpers/routeHelpers"
import { Header } from "pages/AdminApp/Common/Header"
import { MouldsListing } from "./Mould"
import ProductionLineListing from "./ProductionLineListing"

import dailyConfigInactiveIcon from "assets/images/icons/daily-config-icon-inactive.svg"
import mouldsActiveIcon from "assets/images/icons/moulds-active-icon.svg"
import mouldsInactiveIcon from "assets/images/icons/moulds-inactive-icon.svg"
import dailyConfigActiveIcon from "assets/images/icons/daily-config-icon-active.svg"

const TABS_KEYS = {
   PRODUCTION_LINE: "productionLine",
   MOULD: "mould",
}
const TABS_NAME = {
   ProductionLines: "Production Lines",
   Mould: "Mould",
}
const ROUTES_CONFIG = [
   {
      name: TABS_NAME.ProductionLines,
      exact: false,
      component: ProductionLineListing,
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_LISTING,
   },
   {
      name: TABS_NAME.Mould,
      exact: false,
      component: MouldsListing,
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_MOULD,
   },
]
const TABS_CONFIG = [
   {
      title: TABS_NAME.ProductionLines,
      identifier: TABS_KEYS.PRODUCTION_LINE,
      icon: dailyConfigInactiveIcon,
      activeIcon: dailyConfigActiveIcon,
      path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_LISTING,
   },
   //Not needed for now
   //  {
   //    title: TABS_NAME.Mould,
   //    identifier: TABS_KEYS.MOULD,
   //    icon: mouldsInactiveIcon,
   //    activeIcon: mouldsActiveIcon,
   //    path: APP_ROUTES.PRODUCTION_LINE_MANAGEMENT_MOULD,
   // },
]

const ProductionLineManagement = ({}) => {
   return (
      <>
         <Row>
            <Col className="col-12">
               <Header
                  headerTitle="Production Line"
                  showButton={false}
                  showSearch={false}
                  // btnTitle={
                  //    !!isActive.productionSchedule
                  //       ? "Create Order"
                  //       : "Add Trailer "
                  // }
                  // onClick={handleAddTrailer}
                  // onChangeHandler={handleSearchChange}
                  // searchText={searchText}
                  headerBtnResponsive="ad-header-btn-responsive"
                  searchResponsiveness="admin-user-mangement-search-responsiveness"
                  flexResponsive="ad-user-mangement"
                  flexResponsiveInner="ad-user-management-inner"
                  SearchBoxContainer="ad-search-box-container"
               />
            </Col>
         </Row>
         <TabRoute tabConfig={TABS_CONFIG} routesConfig={ROUTES_CONFIG} />
      </>
   )
}
export default ProductionLineManagement
